// Small, dependency-free math helpers shared across systems.

export const clamp = (v: number, lo: number, hi: number): number =>
  v < lo ? lo : v > hi ? hi : v;

export const lerp = (a: number, b: number, t: number): number => a + (b - a) * t;

export const invLerp = (a: number, b: number, v: number): number =>
  a === b ? 0 : (v - a) / (b - a);

export const smoothstep = (t: number): number => {
  const x = clamp(t, 0, 1);
  return x * x * (3 - 2 * x);
};

/** Frame-rate independent exponential damping factor for `lerp(current, target, f)`. */
export const dampFactor = (lambda: number, dt: number): number =>
  1 - Math.exp(-lambda * dt);

export const damp = (current: number, target: number, lambda: number, dt: number): number =>
  lerp(current, target, dampFactor(lambda, dt));

export const TAU = Math.PI * 2;

export const randRange = (lo: number, hi: number): number => lo + Math.random() * (hi - lo);
